import { render, staticRenderFns } from "./SwiperBanner.vue?vue&type=template&id=fa99dc12&scoped=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=js"
export * from "./SwiperBanner.vue?vue&type=script&lang=js"
import style0 from "./SwiperBanner.vue?vue&type=style&index=0&id=fa99dc12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa99dc12",
  null
  
)

export default component.exports